export default __webpack_public_path__ + "static/media/carouselArrowRight.dfaf0721.svg";